import { toast } from "react-toastify";

export const hotelsErrorMsgs = {
  general: {
    no_session: (
      <p>An unexpected error occurred. We are sorry for the incovenience. Please try again.</p>
    ),
    not_exist: (
      <p>This product does not exist or the session has expired. Please make a new search.</p>
    ),
  },
  searchForm: {
    init_search: (
      <p>We couldn't initiate this search. We are sorry for the incovenience. Please try again.</p>
    ),
  },
};
export const activitiesErrorMsgs = {
  general: {
    no_session: (
      <p>An unexpected error occurred. We are sorry for the incovenience. Please try again.</p>
    ),
    not_exist: (
      <p>This product does not exist or the session has expired. Please make a new search.</p>
    ),
  },
  searchForm: {
    init_search: (
      <p>
        We couldn't initiate this search. We are sorry for the incovenience. Please try again later.
      </p>
    ),
  },
  resultsList: {
    no_results: <p>We couldn't find any activities results. We are sorry for incovenience. </p>,
  },
  detailView: {
    no_availability: (
      <p>
        The selected Activity is not available anymore. Please make a new search or select another
        activity.
      </p>
    ),
    no_availability_for_date: (
      <p>The Activity is not available on this date. Please choose a different date.</p>
    ),
    no_date_for_pickup_point: (
      <p>
        The Activity has no available date for this pickup point. Please choose a different pickup
        point.
      </p>
    ),
    select_pick_up_point: <p>Please select a pickup point.</p>,
  },
  prebook: {
    prebook_failed: "",
  },
  guestValidation: {
    init_guests_fail: <p>Please fill all the required fields.</p>,
  },
};

export const transfersErrorMsgs = {
  general: {
    no_session: (
      <p>An unexpected error occurred. We are sorry for the incovenience. Please try again.</p>
    ),
    not_exist: (
      <p>This product does not exist or the session has expired. Please make a new search.</p>
    ),
  },
  searchForm: {
    init_search: (
      <p>
        We couldn't initiate this search. We are sorry for the incovenience. Please try again later.
      </p>
    ),
  },
  resultsList: {
    no_results: <p>We couldn't find any transfers results. We are sorry for incovenience.</p>,
  },
  detailView: {
    no_availability: (
      <p>
        The selected Transfer is not available anymore. Please make a new search or select another
        transfer.
      </p>
    ),
  },
  prebook: {
    prebook_failed: "",
  },
  formValidation: {
    missing_fields: <p>Please fill all the required fields.</p>,
  },
};

export function carRentalErrorMsgs(t) {
  return {
    general: {
      no_session: (
        <p>An unexpected error occurred. We are sorry for the incovenience. Please try again.</p>
      ),
      not_exist: (
        <p>This product does not exist or the session has expired. Please make a new search.</p>
      ),
    },
    searchForm: {
      init_search: (
        <p>
          We couldn't initiate this search. We are sorry for the inconvenience. Please try again
          later.
        </p>
      ),
    },
    resultsList: {
      no_results: <p>{t("carRentalsNotFound")}</p>,
    },
    detailView: {
      no_availability: (
        <p>
          The selected Car Rental is not available anymore. Please make a new search or select
          another Car Rental.
        </p>
      ),
    },
    bookingProcess: {
      fillTheForm: <p>Please fill all fields in the form with driver's info.</p>,
    },
  };
}

export const flightsErrorMsgs = {
  general: {
    unexpectedError: (
      <p>An unexpected error occurred. We are sorry for the incovenience. Please try again.</p>
    ),
  },
  searchForm: {
    init_search: (
      <p>We couldn't initiate this search. We are sorry for the incovenience. Please try again.</p>
    ),
  },
  resultsList: {},
  guestValidation: {},
};

export const ferriesErrorMsgs = {
  general: {
    unexpectedError: (
      <p>An unexpected error occurred. We are sorry for the incovenience. Please try again.</p>
    ),
  },
  searchForm: {
    init_search: (
      <p>We couldn't initiate this search. We are sorry for the incovenience. Please try again.</p>
    ),
  },
  resultsList: {
    no_results: <p>We couldn't find any Ferries results. We are sorry for inconvenience.</p>,
  },
  guestValidation: {},
};

export const trainsErrorMsgs = {
  general: {
    unexpectedError: (
      <p>An unexpected error occurred. We are sorry for the incovenience. Please try again.</p>
    ),
  },
  searchForm: {
    init_search: (
      <p>We couldn't initiate this search. We are sorry for the incovenience. Please try again.</p>
    ),
  },
  resultsList: {
    no_results: <p>We couldn't find any Trains results. We are sorry for inconvenience.</p>,
  },
  guestValidation: {},
};

export const profileErrorMsgs = {
  general: {
    emptyFields: <p>Please fill the required fields.</p>,
    apiCallError: <p>We failed to update your profile. Please try again later.</p>,
  },
};

export const registrationErrorMsgs = {
  general: {
    unexpected_error: (
      <p>An unexpected error occurred. We are sorry for the incovenience. Please try again.</p>
    ),
  },
};

export function onError(errorMessage) {
  if (errorMessage) {
    toast.warning(errorMessage, {
      duration: 3000,
    });
  }
}
